import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CloneProjectDto, ProjectDto } from 'projects/shared/src/lib/models/Project';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { ProjectService } from 'projects/shared/src/lib/services/project.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'archive-project-dialog',
  templateUrl: './archive-project-dialog.component.html',
  styleUrls: ['./archive-project-dialog.component.scss']
})
export class ArchiveProjectDialogComponent implements OnInit {

  archiveProjectForm!:FormGroup;
  _db!:string;

  constructor(private formBuilder: FormBuilder,
    public _dialogRef: MatDialogRef<ArchiveProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private oauthService: OAuthServiceService,
    public translate: TranslateService
    ) { }

  ngOnInit(): void {
    // this.oauthService.userData.subscribe({
    //   next: (data) => {
    //     if (typeof data != undefined && data != null) {
    //       let userRoles = data.role as Array<string>;
    //       userRoles.forEach((role: string) => {
    //         if (role === 'admin') {
    //           this._db = role;
    //         }
    //       });
    //     }
    //   }
    // });
    this.createArchiveProjectForm();
  }

  createArchiveProjectForm(){
    this.archiveProjectForm = this.formBuilder.group({
      id:  this.data[0].id,
      comment: [null, Validators.required],
    });
  }

  isFormValid(){
    return this.archiveProjectForm.valid;
  }

  archiveProject(){

    if(this.archiveProjectForm.valid) {
      this._dialogRef.close(this.archiveProjectForm.value);
    }
  }

  cancel() {
    this._dialogRef.close();
  }
}